import dayjs from 'dayjs';
import { Leg, PowerOutage, SensorPoint } from 'seacube-backend/src/api/client';

import { LinechartPoint, store } from './store';
import { resetTripFooter } from './tripFooter';

export const setLegs = (legs: Leg[]) => {
  store.legs = legs;
};

export const setLegsAugmented = () => {
  // Pour chaque leg on récupère le nombre de powerOutage qui ont une date de début et de fin comprise dans le timestamp du leg
  store.legsAugmented = store.legs.map((l: Leg) => {
    const legStart = dayjs(l.start_datetime).valueOf();
    const legEnd = dayjs(l.end_datetime).valueOf();
    let countPowerOutage = 0;
    let countTemperatureBreach = 0;
    store.powerOutages.filtered.forEach((p: PowerOutage) => {
      const powerOutageStart = dayjs(p.start_datetime).valueOf();

      if (powerOutageStart >= legStart && powerOutageStart < legEnd) {
        countPowerOutage++;
      }
    });
    store.temperatureBreaches.filtered.forEach((p) => {
      const temperatureBreachStart = dayjs(p.start_datetime).valueOf();
      if (
        temperatureBreachStart >= legStart &&
        temperatureBreachStart < legEnd
      ) {
        countTemperatureBreach++;
      }
    });

    return {
      ...l,
      events: {
        powerOutage: countPowerOutage,
        temperatureBreach: countTemperatureBreach,
      },
    };
  });
};
export const setSelectLegs = (legs: Leg[]) => {
  resetTripFooter();

  store.selectedLegs = legs;
};

export const setSelectedLegId = (selectedLegId: string) => {
  store.selectedLegId = selectedLegId;
};

export const clearSelectedLegId = () => {
  store.selectedLegId = undefined;
};
